/**
 * Dashboard branding — the repo's default look-and-feel, centralised.
 *
 * The design *tokens* (colors, radius, fonts, risk/finality palettes) live in
 * `@authe/ui-core`'s Tailwind theme; tenant overrides come through the JWT and
 * are applied by `<TenantProvider>`. This module only carries the few app-level
 * brand defaults the dashboard ships with before any tenant override loads.
 */
import type { BrandOverride } from "@authe/ui-core/theme";

export const APP_NAME = "Authe";
export const APP_TAGLINE = "Blockchain Compliance & Forensics";

/** localStorage key for the persisted light/dark/system preference. */
export const THEME_STORAGE_KEY = "dashboard-theme";

/**
 * Default brand applied at boot (overridden per-tenant at runtime via the JWT
 * `branding` claim → `<TenantProvider branding=…>`). Values map to the
 * `--brand*` CSS variables ui-core's theme reads.
 */
export const DEFAULT_BRAND: BrandOverride = {
  brand: "221 83% 53%",
  brandForeground: "210 40% 98%",
};
